import DIApi from './_diApi';

class EmployeeAPI extends DIApi {
  controllerName = 'employee';
}

export default new EmployeeAPI();
